import React, { useState } from 'react'

import ReportsDemoTable, { ReportsDemoCells, ReportsDemoRow, ReportsDemoSelectionBar } from 'Pages/ReportsAlerts/Reports/@components/DemoTable'


const DEMO_REPORTS = [
	{
		name: 'Spain - Malaga Airport Weekly',
		searches: 384,
		sites: ['rentalspot.demo', 'pricefly.demo'],
		hours: ['08:00', '14:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays'],
		pickup: 'Malaga Airport (AGP)',
		dropoff: null,
		date: '10 Feb 2025 08:15',
		status: 'ready',
		enabled: true,
		hasAnalyzers: true,
	},
	{
		name: 'UK - Heathrow Daily Monitor',
		searches: 1250,
		sites: ['bookride.demo', 'findwheels.demo', 'autolink.demo'],
		hours: ['06:00', '12:00', '18:00'],
		frequency: ['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays'],
		pickup: 'Heathrow Airport (LHR)',
		dropoff: null,
		date: null,
		status: 'running',
		progress: 67,
		completeTasks: '838',
		totalTasks: '1250',
		enabled: true,
		hasAnalyzers: false,
	},
	{
		name: 'France - Paris CDG Brokers',
		searches: 192,
		sites: ['rentalspot.demo'],
		hours: ['10:00'],
		frequency: ['Tuesdays', 'Thursdays'],
		pickup: 'Paris CDG Airport (CDG)',
		dropoff: 'Paris Orly (ORY)',
		date: '08 Feb 2025 10:22',
		status: 'ready',
		enabled: true,
		hasAnalyzers: true,
	},
	{
		name: 'Italy - Rome FCO Rating',
		searches: 96,
		sites: ['pricefly.demo', 'bookride.demo'],
		hours: ['09:00'],
		frequency: ['Mondays'],
		pickup: 'Rome Fiumicino (FCO)',
		dropoff: null,
		date: '03 Feb 2025 09:10',
		status: 'stopped',
		enabled: false,
		hasAnalyzers: false,
	},
	{
		name: 'Germany - Munich MUC Full',
		searches: 576,
		sites: ['rentalspot.demo', 'pricefly.demo', 'findwheels.demo'],
		hours: ['07:00', '13:00', '19:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays', 'Sundays'],
		pickup: 'Munich Airport (MUC)',
		dropoff: null,
		date: '10 Feb 2025 19:03',
		status: 'ready',
		enabled: true,
		hasAnalyzers: true,
	},
]

// The quick links each finished report shows under its date
const linksOf = r => r.hasAnalyzers ? ['lor', 'dor', 'brokers', 'direct', 'rating', 'realtime', 'categories', 'acriss', 'multireport', 'multiexport'] : ['multireport', 'multiexport']

export default function ReportsDemoData() {
	// ticked rows, as the real table keeps them: the selection bar shows while one is ticked
	const [selected, setSelected] = useState([])
	const toggle = name => setSelected(list => list.includes(name) ? list.filter(n => n !== name) : [...list, name])

	return <ReportsDemoTable
		title="Reports List"
		count={DEMO_REPORTS.length}
		selection={!!selected.length && <ReportsDemoSelectionBar reports={DEMO_REPORTS.filter(r => selected.includes(r.name))} onClear={() => setSelected([])}/>}
	>
		{DEMO_REPORTS.map(r => <ReportsDemoRow key={r.name} selected={selected.includes(r.name)} onToggle={() => toggle(r.name)}>
			<ReportsDemoCells report={r} links={linksOf(r)} withForce/>
		</ReportsDemoRow>)}
	</ReportsDemoTable>
}
